import { useContext } from 'react';

import { AnalyticsContext } from '@/contexts/analytics/AnalyticsContext';

export const useAnalytics = () => {
  const context = useContext(AnalyticsContext);
  if (!context) {
    throw new Error('useAnalytics must be used within AnalyticsContextProvider');
  }
  return context;
};

export default useAnalytics;
